import React, {Component} from 'react';
import PropTypes from 'prop-types';

class PopoverBtn extends Component {
  constructor(props) {
    super(props);

    this.enableThumbPopover = this.enableThumbPopover.bind(this);
  }

  componentDidMount() {
    this.enableThumbPopover();
  }

  enableThumbPopover() {
    let counter;

    $('.popovers').popover({
      trigger: 'manual',
      animation: false,
      html: true,
      title: function() {
        return $(this).parent().find('.thumbPopover').data('content-title');
      },
      content: function() {
        return $(this).parent().find('.thumbPopover').data('content-body');
      },
      container: 'body',
      placement: 'bottom',
    }).on('mouseenter', function() {
      // eslint-disable-next-line no-invalid-this
      const _this = this; // popovers

      // clear the counter
      clearTimeout(counter);
      // Close all other Popovers
      $('.popovers').not(_this).popover('hide');

      // start new timeout to show popover
      counter = setTimeout(function() {
        if ($(_this).is(':hover')) {
          $(_this).popover('show');
        }
        $('.popover').on('mouseleave', function() {
          $('.popovers').popover('hide');
        });
      }, 400);
    }).on('mouseleave', function() {
      // eslint-disable-next-line no-invalid-this
      const _this = this;

      setTimeout(function() {
        if (!$('.popover:hover').length) {
          if (!$(_this).is(':hover')) {
            $(_this).popover('hide');
          }
        }
      }, 200);
    });
  }

  render() {
    return (
      <section
        className={`${this.props.viewClass} popovers popover_btn`}
        style={{borderRadius: '5px', backgroundColor: 'white'}}
      >
        <div
          className="thumbPopover"
          data-content-body={this.props.popoverContent}
          data-content-title={this.props.title}
        >
          <strong className="title">{this.props.title}</strong>
        </div>
      </section>
    );
  }
}

PopoverBtn.propTypes = {
  viewClass: PropTypes.string,
  title: PropTypes.string,
  popoverTitle: PropTypes.string,
  popoverContent: PropTypes.string,
};
PopoverBtn.defaultProps = {};

export default PopoverBtn;
